import React from 'react';
import {Button, Col, Container, Row} from "react-bootstrap";
import styles from "./ImageCard.module.css";
import {ArrowBackIos, ArrowForwardIos} from "@mui/icons-material";
import imageCardData from "./imageCardData/imageCardData";

function ImageCard() {
    return (
        <Container>
            <Row className='pt-4'>
                <h4>Countries you can travel to right now</h4>
                <Col>
                    <p>Popular destinations open to visitors from your country</p>
                </Col>
                <Col>
                    <Button className='mx-4' style={{float: 'right'}} variant={"outline-primary"}>See All</Button>
                </Col>
            </Row>
            <Row className='mt-3'>
                {imageCardData.map((item, key) => {
                    return (
                        <Col key={key}>
                            <div className={`${styles.card}`}>
                                <img className={`${styles.cardImg}`} src={item.img} alt=""/>
                            </div>
                            <div className={`${styles.cardContent}`}>
                                <div className={`${styles.cardTop}`}>
                                    <span>{item.access}</span>
                                </div>
                                <div className={`${styles.cardContentTitle}`}>
                                    <span>{item.title}</span>
                                </div>
                                <div className={`${styles.cardContentDescription}`}>
                                    <span>{item.description}</span>
                                </div>
                                <div className={`${styles.cardBottom}`}>
                                    <span>{item.howImportant}</span>
                                </div>
                            </div>
                        </Col>
                    )
                })}
            </Row>
            <Row style={{float: 'right'}}>
                <Col xs='md' className='mx-4'>
                    <ArrowBackIos/>
                    <ArrowForwardIos/>
                </Col>
            </Row>
        </Container>
    );
}

export default ImageCard;
